import React from 'react'
import { Modal } from 'jd-library'
import withPortal from 'jd-library/withPortal';

const MultiPerIssueModal = (props) => {
    const { onHidden, isOwner, isPaid, productOrService } = props
    return (
        <Modal
            settings={{
                modalId: "MultiPerIssue",
                variant: "action",
                class: "multi-per-issue-modal",
            }}
            backdropStatic={true}
            onHidden={onHidden}
        >
            <Modal.Header>
                Unrelated Category Selected
            </Modal.Header>
            <Modal.Body className={'multi-per-issue-body'}>
                {`It seems like you have selected a category which is unrelated to your business. Please change the ${productOrService} category
          ${isOwner && isPaid ? ' or call 022-50960001 for support' : ''}`
                }
            </Modal.Body>
            <Modal.CenterButton
                clickHandler={() => { window.history.go(-1) }}
            >
                {"Okay, Got it"}
            </Modal.CenterButton>
        </Modal>
    )
}

export default withPortal(MultiPerIssueModal);
